/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */

export type DroneResponseOwnershipStatus =
    (typeof DroneResponseOwnershipStatus)[keyof typeof DroneResponseOwnershipStatus];

export const DroneResponseOwnershipStatus = {
    CLAIMED: 'CLAIMED',
    ENABLED: 'ENABLED',
    RELEASED: 'RELEASED'
} as const;
